module.exports = function(TomSelect, Modal, params) {

	const otpModalElm = document.getElementById("otp-modal");
	const otpInput = document.getElementById("otp-input");
	const otpError = otpModalElm.getElementsByClassName("js-error")[0];
	const verifyOtpBtn = document.getElementById("verify-otp-btn");

	const otpModal = new Modal({
		modal: otpModalElm,
		staticBackdrop: true
	});

	otpModalElm.addEventListener("modal.is.hidden", function() {
		checkExistingCustomerBtn.getElementsByClassName("js-spinner")[0]
			.classList.add("hidden");
		checkExistingCustomerBtn.disabled = false;
		otpError.classList.add("hidden");
		verifyOtpBtn.disabled = false;

		otpInput.value = "";
	});

	
	
	verifyOtpBtn.addEventListener("click", function() {
		const spinner = this.getElementsByClassName("js-spinner")[0];
		spinner.classList.remove("hidden");
		this.disabled = true;
		otpError.classList.add("hidden");
		
		axios.post("/vefiry-existing-subscriber", {
			otp: otpInput.value
		})
		.then(res => {

			const customerDataCnt = document.getElementById("existing-customer-data");
			customerDataCnt.innerHTML = res.data.html;
			document.getElementById("customer-id-cnt").classList.add("hidden");

			const keepNumberRadio = document.getElementById("keep-number");

			if (keepNumberRadio != null && keepNumberRadio.checked) {
				const mobileNumberCnts = document.getElementsByClassName("js-customer-mobile-number-cnt");
				for (let i = 0; i < mobileNumberCnts.length; i++) {
					mobileNumberCnts[i].classList.add("hidden");
				}
			}
			
			require("./existing-customer")(TomSelect);
			
			if (params?.hasDevice) {

				require("./registration-type-warning")(customerDataCnt)
			}
			
			document.getElementById("customer-tabs")
				.scrollIntoView({behavior: "smooth"});

			otpModal.closeModal();
		})
		.catch(err => {

			console.log(err);

			if (err.response.status === 422) {
				otpError.textContent = err.response.data.message;
				otpError.classList.remove("hidden");
			}
			this.disabled = false;
		})
		.finally(() => {

			spinner.classList.add("hidden");
		})
	});

	const customerIdInput = document.getElementById("customer-id-input");
	const customerIdError = document.getElementById("customer-id-error");

	const checkExistingCustomerBtn = document.getElementById("check-existing-customer-btn");
	checkExistingCustomerBtn.addEventListener("click", function() {

		if ( customerIdInput.value == "" ) {
			
			return false;
		}
		
		const spinner = this.getElementsByClassName("js-spinner")[0];
		spinner.classList.remove("hidden");
		this.disabled = true;
		customerIdError.textContent = "";


		axios.post("/check-existing-subscriber", {
			customerId: customerIdInput.value
		})
		.then(res => {
			otpModalElm.getElementsByClassName("js-message")[0]
				.textContent = res.data.message;
			otpModal.openModal();
			spinner.classList.add("hidden");
		})
		.catch(err => {

			if (err.response.status == 422) {
				customerIdError.textContent = err.response.data.message;
			}
		})
		.finally(() => {
			spinner.classList.add("hidden");
			this.disabled = false;
		})
	});
};